import type * as api from '@gitbook/api-client';
import { assertNever } from '@gitbook/util-ts';

import type { DNDItem } from './types';

/**
 * Convert a dragged item into a content ref.
 */
export function getContentRefForDND(item: DNDItem): api.ContentRef {
    switch (item.type) {
        case 'space':
            return { kind: 'space', space: item.id };
        case 'collection':
            return { kind: 'collection', collection: item.id };
        case 'page':
            return { kind: 'page', space: item.space, page: item.id };
        case 'reusable-content':
            return { kind: 'reusable-content', reusableContent: item.id };
        case 'block':
        case 'block-range':
        case 'tab':
        case 'table-record':
        case 'table-definition':
            throw new Error(`Invalid DND item "${item.type}"`);
        default:
            assertNever(item);
    }
}
